
export interface EmojiItem {
    char: string;
    keywords: string; // Space separated keywords
    category: string;
}

export const EMOJI_CATEGORIES = [
    { id: 'recent', icon: '🕒', label: 'Недавние' },
    { id: 'smileys', icon: '😀', label: 'Смайлы' },
    { id: 'people', icon: '👋', label: 'Люди' },
    { id: 'nature', icon: '🐻', label: 'Природа' },
    { id: 'food', icon: '🍔', label: 'Еда' },
    { id: 'activity', icon: '⚽', label: 'Активность' },
    { id: 'travel', icon: '🚗', label: 'Путешествия' },
    { id: 'objects', icon: '💡', label: 'Объекты' },
    { id: 'symbols', icon: '❤️', label: 'Символы' },
];

export const EMOJI_LIST: EmojiItem[] = [
    // Smileys
    { char: '😀', keywords: 'smile happy face grin улыбка смайл счастье', category: 'smileys' },
    { char: '😂', keywords: 'joy tears laugh смех слезы лол', category: 'smileys' },
    { char: '🤣', keywords: 'rolling floor laughing катаюсь смех', category: 'smileys' },
    { char: '😉', keywords: 'wink подмигивание', category: 'smileys' },
    { char: '🥰', keywords: 'love hearts in love влюблен любовь', category: 'smileys' },
    { char: '😍', keywords: 'heart eyes love глаза сердца', category: 'smileys' },
    { char: '😎', keywords: 'sunglasses cool крутой очки', category: 'smileys' },
    { char: '🤔', keywords: 'thinking thought думать мысль', category: 'smileys' },
    { char: '😐', keywords: 'neutral poker face покерфейс', category: 'smileys' },
    { char: '🙄', keywords: 'rolling eyes закатил глаза', category: 'smileys' },
    { char: '😥', keywords: 'sad relieved грусть', category: 'smileys' },
    { char: '😭', keywords: 'cry sob плач рыдания', category: 'smileys' },
    { char: '😱', keywords: 'scream fear fear страх крик', category: 'smileys' },
    { char: '🤯', keywords: 'exploding head взрыв мозга шок', category: 'smileys' },
    { char: '🥳', keywords: 'party popper праздник вечеринка', category: 'smileys' },
    { char: '😡', keywords: 'angry mad злость ярость', category: 'smileys' },
    { char: '🤡', keywords: 'clown face клоун цирк', category: 'smileys' },
    { char: '💩', keywords: 'poop shit какашка', category: 'smileys' },
    
    // People & Body
    { char: '👋', keywords: 'wave hand hello привет пока', category: 'people' },
    { char: '👍', keywords: 'thumbs up like ok класс лайк', category: 'people' },
    { char: '👎', keywords: 'thumbs down dislike дизлайк', category: 'people' },
    { char: '👏', keywords: 'clap applause аплодисменты хлопать', category: 'people' },
    { char: '🙏', keywords: 'pray please thank you пожалуйста спасибо', category: 'people' },
    { char: '💪', keywords: 'muscle strong сила мышцы', category: 'people' },
    { char: '🤝', keywords: 'handshake deal рукопожатие договор', category: 'people' },
    { char: '👀', keywords: 'eyes look глаза смотреть', category: 'people' },

    // Nature
    { char: '🐶', keywords: 'dog puppy собака пес щенок', category: 'nature' },
    { char: '🐱', keywords: 'cat kitten кошка кот котенок', category: 'nature' },
    { char: '🐻', keywords: 'bear bear медведь', category: 'nature' },
    { char: '🔥', keywords: 'fire hot огонь жара топ', category: 'nature' },
    { char: '✨', keywords: 'sparkles stars блеск звезды', category: 'nature' },
    { char: '🌟', keywords: 'star glow звезда сияние', category: 'nature' },
    { char: '☀️', keywords: 'sun sunny солнце ясно', category: 'nature' },
    { char: '🌧️', keywords: 'cloud rain дождь тучи', category: 'nature' },
    { char: '🌲', keywords: 'tree evergreen дерево елка лес', category: 'nature' },
    { char: '🌸', keywords: 'cherry blossom flower цветок сакура', category: 'nature' },

    // Food
    { char: '🍏', keywords: 'green apple яблоко фрукт', category: 'food' },
    { char: '🍔', keywords: 'hamburger burger бургер еда', category: 'food' },
    { char: '🍕', keywords: 'pizza пицца', category: 'food' },
    { char: '☕', keywords: 'coffee tea drink кофе чай напиток', category: 'food' },
    { char: '🍺', keywords: 'beer mug пиво алкоголь', category: 'food' },
    { char: '🎂', keywords: 'birthday cake торт день рождения', category: 'food' },

    // Activity
    { char: '⚽', keywords: 'soccer ball football футбол мяч спорт', category: 'activity' },
    { char: '🏀', keywords: 'basketball баскетбол', category: 'activity' },
    { char: '🎮', keywords: 'video game controller play игра геймпад', category: 'activity' },
    { char: '🎨', keywords: 'artist palette art искусство рисование', category: 'activity' },
    { char: '🎤', keywords: 'microphone sing karaoke микрофон петь', category: 'activity' },

    // Travel
    { char: '🚗', keywords: 'car red auto машина автомобиль', category: 'travel' },
    { char: '✈️', keywords: 'airplane flight самолет полет', category: 'travel' },
    { char: '🚀', keywords: 'rocket blast off ракета космос', category: 'travel' },
    { char: '🏝️', keywords: 'desert island beach остров пляж отпуск', category: 'travel' },
    { char: '🗺️', keywords: 'world map карта путешествие', category: 'travel' },

    // Objects
    { char: '💡', keywords: 'light bulb idea идея свет лампа', category: 'objects' },
    { char: '💰', keywords: 'money bag dollar деньги богатство', category: 'objects' },
    { char: '📱', keywords: 'mobile phone phone телефон смартфон', category: 'objects' },
    { char: '🎁', keywords: 'wrapped gift present подарок сюрприз', category: 'objects' },
    { char: '🔔', keywords: 'bell notification колокольчик уведомление', category: 'objects' },
    { char: '📅', keywords: 'calendar date календарь дата', category: 'objects' },

    // Symbols
    { char: '❤️', keywords: 'red heart love любовь сердце', category: 'symbols' },
    { char: '💔', keywords: 'broken heart разбитое сердце', category: 'symbols' },
    { char: '💯', keywords: 'hundred points 100 сто', category: 'symbols' },
    { char: '✅', keywords: 'check mark button галочка чек', category: 'symbols' },
    { char: '❌', keywords: 'cross mark x крестик отмена', category: 'symbols' },
    { char: '⚠️', keywords: 'warning sign danger внимание опасность', category: 'symbols' },
    { char: '‼️', keywords: 'double exclamation mark восклицание', category: 'symbols' },
    { char: '➡️', keywords: 'right arrow стрелка вправо', category: 'symbols' },
];
